import type { ReactNode } from "react";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import { OptionalTextMapper } from "../summary";

export function SummarySection({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="summary-section">
      <div className="summary-title">{title}</div>
      {children}
    </div>
  );
}

export function SummaryGrid({ children }: { children: ReactNode }) {
  return <div className="summary-grid">{children}</div>;
}

export function SummaryRow({ label, children }: { label: string; children: ReactNode }) {
  return (
    <>
      <div className="summary-label">{label}</div>
      <div className="summary-value">{children}</div>
    </>
  );
}

export function NotProvided({ text }: { text: string }) {
  return <span className="not-req">{text}</span>;
}

export function ReviewValue({ value }: { value: string }) {
  const copy = useQuoteCopy();
  const provided = new OptionalTextMapper().provided(value);
  return provided ?? <NotProvided text={copy.t("common.notProvided")} />;
}
